import { useEffect, useState } from "react";
//import { Row, Col, Card, Button } from "react-bootstrap";
//import { useMediaQuery } from 'react-responsive';
import { Link, useNavigate, useHref } from "react-router-dom";

import { styled } from '@mui/material/styles';
import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Rating from '@mui/material/Rating';
import Typography from '@mui/material/Typography';
import Switch from '@mui/material/Switch';
import Container from '@mui/material/Container';
import Alert from '@mui/material/Alert';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import CircularProgress from '@mui/material/CircularProgress';
import useMediaQuery from '@mui/material/useMediaQuery';
import Tooltip from '@mui/material/Tooltip';

import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';

import * as React from 'react';
import Collapse from '@mui/material/Collapse';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import { red } from '@mui/material/colors';
import FavoriteIcon from '@mui/icons-material/Favorite';
import ShareIcon from '@mui/icons-material/Share';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import AddBoxTwoToneIcon from '@mui/icons-material/AddBoxTwoTone';

const config = require("../../../constants/constants.js")

const widthCard = 250;

const ElementCardForPageComponent = ({ category, idx }) => {

  const url_image_elencoservizi = config.URL_IMAGES_CUSTOMER1 + "cestino.png";
  const help_image_elencoservizi = "cancella";
  const url_elencoservizi = "/product-list/category/" + category.name;

  let navigate = useNavigate();

  const [expanded, setExpanded] = React.useState(false);

  return (

    <Card
      sx={{
        width: widthCard,
        minWidth: widthCard,
        border: 1,
        borderColor: '#0c2b85',
        margin: 1,
        paddingTop: 2, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
        backgroundColor: '#ffffff',
        '&:hover': {
          backgroundColor: '#e9e9e9',
          opacity: [0.9, 0.8, 0.7],
        },
      }}
    >

      <CardMedia
        component="img"
        //image={category.images[0] ? category.images[0].path : ''}
        image="/images-0001/categories/38b72c04-eea0-4eee-911a-fd7a7524be89.jpg"
        alt=""
        //sx={{ width: 300, paddingTop: 2, paddingLeft: 2, paddingRight: 2 }}
        sx={{ width: widthCard - 32, paddingTop: 2, paddingBottom: 0, paddingLeft: 2, paddingRight: 2 }}
      >
      </CardMedia>

      <CardContent>
        <Typography variant="body1"
          sx={{
            fontFamily: 'Arial',
            fontWeight: 500,
            fontSize: 16,
            color: 'text.secondary',
          }}
        >
          immagine {idx + 1}
        </Typography>

      </CardContent>

      <CardActions disableSpacing>

        <Link to={url_elencoservizi}>
          <Tooltip title={help_image_elencoservizi} arrow placement="right-end">
            <Box
              component="img"
              paddingLeft={{ xs: widthCard / 10, md: widthCard / 10 }}
              sx={{
                height: 25,
                width: 25,
                maxHeight: { xs: 25, md: 25 },
                maxWidth: { xs: 25, md: 25 },
              }}
              src={url_image_elencoservizi}
              onClick={() => {
                navigate(url_elencoservizi)
              }}
            >
            </Box>
          </Tooltip>

        </Link>

      </CardActions>

    </Card>

  );
};

export default ElementCardForPageComponent;
